import { styled } from '@uhg-abyss/web/tools/styled';

export const BannerTitle = styled('div', {
  fontWeight: '400',
  fontSize: '16px',
  color: '#4B4D4F',
});
